import '@babel/polyfill'
import 'mutationobserver-shim'
import './plugins/bootstrap-vue'
import Vue from 'vue'
import App from './App.vue'
// import VueRouter from 'vue-router'
import router from "@/router";
import store from './store'
import i18n from './i18n'
import VueScrollmagic from 'vue-scrollmagic'
import vueSmoothScroll from 'vue2-smooth-scroll'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

// import view_1 from "@/views/view_1.vue";
// import view_2 from "@/views/view_2.vue";
// import view_3 from "@/views/view_3.vue";

// Vue.use(VueRouter)
Vue.use(VueScrollmagic)
Vue.use(vueSmoothScroll)
Vue.use(VueAwesomeSwiper, /* { default global options } */)

Vue.config.productionTip = false

// const router = new VueRouter({
//   mode: 'history',
//   routes: [
//     {path: '/', component: view_1},
//     {path: '/page_2', component: view_2},
//     {path: '/page_3', component: view_3}
//   ]
// })

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

i18n.locale = 'en'
